export * from './translator.module';
